import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter, Link } from "react-router-dom";
import axios from "axios";
import "../../css/event20230410.css";
import { toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)
import { Modal } from "react-responsive-modal";
import queryString from "query-string";
import { Base64 } from "js-base64";
class Login_ugc extends Component {
  state = {
    userid: "",
    password: "",
  };
  componentDidMount = () => {
    this.userid.focus();
  };
  _onUseridChange = (e) => {
    ////console.log(e.target.value)
    this.setState({
      userid: e.target.value,
    });
  };
  _onPasswordChange = (e) => {
    this.setState({
      password: e.target.value,
    });
  };
  setCookie = (name, value, exp) => {
    let expires;
    if (exp) {
      var date = new Date();
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
      expires = date.toGMTString();
    } else {
      expires = "";
    }

    //console.log(expires)
    document.cookie =
      name +
      "=" +
      value +
      ";path=/;expires=" +
      expires +
      "; SameSite=None; Secure; domain=aniplustv.com"; // SameSite=None; Secure; 실서비스 시 추가할 것.
  };
  _onLogin = async () => {
    const {
      setAParam,

      setAuthId,
      setLoginId,
      setData,
      setBitrate,
      setDownloadBitrate,
      setAutoNext,
      setPlayer,
      setPkg,
      setIcon,
      setNicName,
      history,

      setPollShow,
    } = this.props;
    const { userid, password, chkValue } = this.state;

    const { location } = this.props.childProps;
    const query = queryString.parse(location.search);
    ////console.log(query)
    const refer = query.r;

    // console.log(refer)

    if (userid === "" || userid === undefined || userid === null) {
      toast.warn("아이디를 입력해 주세요");
      return false;
    }
    if (password === "" || password === undefined || password === null) {
      toast.warn("패스워드를 입력해 주세요");
      return false;
      //alert('패스워드가 누락되었습니다.')
    }

    const result = await this._onLoginApi();
    const intReturn = result.data[0].intReturn;
    // const messageCount = result.data[0].messageCount;
    const icon = result.data[0].charac_Img;

    const listData = result.data[0].listData;
    ////console.log(intReturn)
    ////console.log(listData)
    ////console.log(icon)
    //console.log(result.data[0].pkg)

    if (intReturn === 0) {
      //cookies
      const at = result.data[0].at;
      const rt = result.data[0].rt;
      const base64Data = await this._getBase64Encode(userid, listData[0].pkg);

      //console.log(at)
      //console.log(rt)

      if (
        base64Data.data.codeString === "" ||
        base64Data.data.codeString === null ||
        base64Data.data.codeString === undefined
      ) {
        toast.error("오류가 발생했습니다. 다시 시도해 주세요");
        this.setState({
          loginLoading: false,
        });
      } else {
        //
        const authId1 = base64Data.data.codeString; /*소핑몰과 연동됨 */

        const authId = Base64.encode(userid);
        //console.log(Base64.encode('badguyson'))
        //console.log(await this._getBase64Encode('badguyson'))
        //console.log(Base64.decode('YWRtaW4='))

        localStorage.setItem("at", at);
        localStorage.setItem("rt", rt);

        let expires = new Date();
        expires.setDate(Date.now() + 1000 * 60 * 60 * 24 * 14);
        let cookieData =
          "messageCount_output=" +
          listData[0].bitrate +
          "&birthDay=" +
          listData[0].birthDay +
          "&memberPartCode=" +
          listData[0].download +
          "&authId=" +
          authId1 +
          "&playerFlag=" +
          listData[0].playerFlag +
          "&couponCount=" +
          listData[0].autoNext +
          "&jumin=" +
          listData[0].jumin +
          "&point=" +
          listData[0].point +
          "&sex=" +
          listData[0].sex +
          "&loginCode=" +
          listData[0].loginCode +
          "&loginId=" +
          userid +
          "&pkg=" +
          listData[0].pkg +
          "&loginName=" +
          encodeURIComponent(listData[0].nicName);
        ////console.log(cookieData)
        this.setCookie("account", cookieData);

        //const pollIdx = listData[0].pollIdx
        //const pollEndIdx = listData[0].pollEndIdx

        const pollIdx = 0;
        const pollEndIdx = 100;

        //console.log(authId)

        setAuthId(authId);
        setAParam(authId1);
        setLoginId(userid);
        setData(listData);
        setIcon(icon);

        setBitrate(listData[0].bitrate);
        setDownloadBitrate(listData[0].download);
        setAutoNext(listData[0].autoNext);
        setPlayer(listData[0].player);
        setNicName(listData[0].nicName);
        setPkg(listData[0].pkg);

        if (chkValue) {
          ////console.log('local storage...save')
          localStorage.setItem("aplsUid", userid);
        } else {
          localStorage.removeItem("aplsUid");
        }

        this.setState({
          loginLoading: false,
        });

        setTimeout(() => {
          // if ( document.referrer ) {
          if (refer === "s") {
            document.location.href = "https://shop.aniplustv.com";
          } else if (refer === "ms") {
            document.location.href = "https://mshop.aniplustv.com";
          } else if (refer === "t") {
            document.location.href = "https://www.aniplustv.com/seat/seat.asp";
          } else {
            //history.go(-1, {from: 'login'})
            //clearCache()
            //console.log(history)
            history.goBack();
            //history.push('/')
          }
          //} else {

          //}
        }, 600);
      }
    } else {
      //alert('계정이 일치하지 않습니다.')
      toast.error("계정이 일치하지 않습니다.");
      this.setState({
        loginLoading: false,
      });
    }
  };
  _getB64e = (codeString) => {
    const { aspUrl } = this.props;
    return axios(aspUrl + "/b64e.asp?codeString=" + codeString)
      .then((response) => response)
      .catch((error) => {
        //console.log('error...')
      });
  };
  _getBase64Encode = (codeString, pkg) => {
    const { aspUrl } = this.props;
    return axios(
      aspUrl +
        "/base64encode_wd.asp?codeString=" +
        codeString +
        "&p=" +
        pkg +
        "&i=" +
        codeString
    )
      .then((response) => response)
      .catch((error) => {
        //console.log('error...')
      });
  };
  _onLoginApi = () => {
    const { apiUrl } = this.props;
    const { userid, password } = this.state;
    this.setState({
      loginLoading: true,
    });
    ////console.log(userid)
    //return axios(apiUrl + '/_onUserid?userid=' + userid)
    //loadProgressBar()
    //return axios.post(aspUrl + '/loginPost.asp', {
    return axios
      .post(apiUrl + "/_onLogin", {
        params: {
          userid: userid,
          password: password,
        },
      })

      .then((response) => response)
      .catch((error) => {
        //console.log(error)
      });
  };
  _enterKey = (e) => {
    const keyCode = e.keyCode;
    if (keyCode === 13) {
      this._onLogin();
    }
  };
  render() {
    const { userid, password } = this.state;
    return (
      <div className="logWrap">
        <div className="log_1">
          <img src="/img/event/event20230410/login_1.png" alt="" />
        </div>
        <div className="logBox">
          <div>
            <input
              name="userid"
              value={userid}
              onChange={this._onUseridChange}
              type="text"
              placeholder="아이디를 입력하세요."
              ref={(ref) => (this.userid = ref)}
            />
          </div>
          <div>
            <input
              type="password"
              name="password"
              value={password}
              onChange={this._onPasswordChange}
              placeholder="비밀번호"
              ref={(ref) => (this.password = ref)}
              onKeyUp={this._enterKey}
            />
          </div>
          <Link to="/find">아이디 / 비밀번호 찾기 &gt;</Link>
        </div>
        <div className="log_2">
          <img src="/img/event/event20230410/login_2.png" alt="" />
        </div>
        <button className="btn_login" onClick={this._onLogin}>
          로그인
        </button>
      </div>
    );
  }
}

export default shopContext(withRouter(Login_ugc));
